import axiosInstance from "@/utils/axiosInstance";
import { wrapFetchValue } from "@/store/modules/storeCache";

const baseUrl = `api/tags`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAll({ commit }, payload: { query: object }) {
    return wrapFetchValue(state, "tags", () => axiosInstance.get(baseUrl, {
      params: payload ? payload.query : {},
    }).then((data) => data.data));
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
